import React, {useEffect, useState} from "react";
import ClayLoadingIndicator from "@clayui/loading-indicator";
import ClayModal, {useModal} from '@clayui/modal';
import ClayButton from "@clayui/button";
import {useTranslation} from "react-i18next";
import {getInsurances} from "../util/Api";

const AddCartModal = ({loading, addCartAction, observer, supportsInsurance, defaultInsuranceId = "0"}) => {
    const {t} = useTranslation();
    const [insurancesLoading, setInsurancesLoading] = useState(false);
    const [insurances, setInsurances] = useState([]);
    const [name, setName] = useState("");
    const [insuranceId, setInsuranceId] = useState(defaultInsuranceId);
    const [insuranceCaseNumber, setInsuranceCaseNumber] = useState("");


    useEffect(() => {
        if(supportsInsurance) {
            setInsurancesLoading(true);
            getInsurances()
                .then(json => setInsurances(json))
                .catch(error => alert(t("an-unexpected-error-occurred")))
                .finally(() => setInsurancesLoading(false));
        }
    }, []);

    return (
        <ClayModal
            observer={observer}
            className="commerce-modal">
            <ClayModal.Header>{t("create-new-order")}</ClayModal.Header>
            <ClayModal.Body>
                {loading ? (
                    <div className="loader-container">
                        <ClayLoadingIndicator/>
                    </div>
                ) : (
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        addCartAction(name, insuranceId, insuranceCaseNumber);
                    }}>
                        <div className="form-group input-text-wrapper has-success">
                            <label className=" control-label"
                                   htmlFor="new-order-name">
                                {t('name')}
                            </label>
                            <input className="field up2d-cockpit-input-panel form-control success-field"
                                   id="new-order-name" required={true}
                                   type="text" value={name} onChange={(e) => setName(e.target.value)}/>
                        </div>

                        {insurances && insurances.length>0 ?
                            (
                                <>

                                    <div className="form-group input-text-wrapper has-success">
                                        <label className="control-label"
                                               htmlFor="insurance-select">
                                            {t('insurance')}
                                        </label>
                                        <select id="insurance-select" className={"form-control success-field"}
                                                value={insuranceId}
                                                onChange={e => setInsuranceId(e.target.value)}>
                                            <option value={0}>{t("no-insurance")}</option>
                                            {insurances.map(insurance => (
                                                <option key={insurance.id} value={insurance.id}>{insurance.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group input-text-wrapper has-success">
                                        <label className={(insuranceId === "0" ? "disabled " : "") + "control-label"}
                                               htmlFor="insurance-case-number">
                                            {t('insurance-case-number')}
                                        </label>
                                        <input disabled={insuranceId === "0"}
                                               className={(insuranceId === "0" ? "disabled " : "") + "field up2d-cockpit-input-panel form-control success-field"}
                                               id="insurance-case-number" required={true}
                                               type="text" value={insuranceCaseNumber}
                                               onChange={(e) => setInsuranceCaseNumber(e.target.value)}/>
                                    </div>
                                </>
                            ) :
                            (
                                <>
                                {insurancesLoading && <ClayLoadingIndicator/> }
                                </>
                            )
                        }

                        <ClayButton type="submit" displayType="primary" className={"w-100"}>
                            {t('add')}
                        </ClayButton>
                    </form>
                )
                }
            </ClayModal.Body>
        </ClayModal>
    )
}

export default AddCartModal;